<template>
    <div class="store-opening-times">

        <h5>Öffnungszeiten <a href="javascript:void(0);" @click="editStore()"><i class="mdi mdi-square-edit-outline"></i></a></h5>

        <div v-if="!editingStore">
            <div><span>Montag:</span><span v-if="!mon_closed">{{ mon_from }} - {{ mon_until }}</span><span v-else>Geschlossen</span></div>
            <div v-if="mon_from2 && mon_until2"><span></span><span>{{ mon_from2 }} - {{ mon_until2 }}</span></div>

            <div><span>Dienstag:</span><span v-if="!tue_closed">{{ tue_from }} - {{ tue_until }}</span><span v-else>Geschlossen</span></div>
            <div v-if="tue_from2 && tue_until2"><span></span><span>{{ tue_from2 }} - {{ tue_until2 }}</span></div>

            <div><span>Mittwoch:</span><span v-if="!wed_closed">{{ wed_from }} - {{ wed_until }}</span><span v-else>Geschlossen</span></div>
            <div v-if="wed_from2 && wed_until2"><span></span><span>{{ wed_from2 }} - {{ wed_until2 }}</span></div>

            <div><span>Donnerstag:</span><span v-if="!thu_closed">{{ thu_from }} - {{ thu_until }}</span><span v-else>Geschlossen</span></div>
            <div v-if="thu_from2 && thu_until2"><span></span><span>{{ thu_from2 }} - {{ thu_until2 }}</span></div>

            <div><span>Freitag:</span><span v-if="!fri_closed">{{ fri_from }} - {{ fri_until }}</span><span v-else>Geschlossen</span></div>
            <div v-if="fri_from2 && fri_until2"><span></span><span>{{ fri_from2 }} - {{ fri_until2 }}</span></div>

            <div><span>Samstag:</span><span v-if="!sat_closed">{{ sat_from }} - {{ sat_until }}</span><span v-else>Geschlossen</span></div>
            <div v-if="sat_from2 && sat_until2"><span></span><span>{{ sat_from2 }} - {{ sat_until2 }}</span></div>

            <div><span>Sonntag:</span><span v-if="!sun_closed">{{ sun_from }} - {{ sun_until }}</span><span v-else>Geschlossen</span></div>
            <div v-if="sun_from2 && sun_until2"><span></span><span>{{ sun_from2 }} - {{ sun_until2 }}</span></div>
        </div>

        <div v-if="editingStore">
            <span>Montag:</span> <input type="text" v-model="mon_from"> - <input type="text" v-model="mon_until"><br />
            <div class="mt-1"><span></span> <input type="text" v-model="mon_from2"> - <input type="text" v-model="mon_until2"></div>
            <small><input type="checkbox" v-model="mon_closed" id="mon_closed"> <label for="mon_closed">Montag geschlossen</label></small>

            <span>Dienstag:</span> <input type="text" v-model="tue_from"> - <input type="text" v-model="tue_until"><br />
            <div class="mt-1"><span></span> <input type="text" v-model="tue_from2"> - <input type="text" v-model="tue_until2"></div>
            <small><input type="checkbox" v-model="tue_closed" id="tue_closed"> <label for="tue_closed">Dienstag geschlossen</label></small>

            <span>Mittwoch:</span> <input type="text" v-model="wed_from"> - <input type="text" v-model="wed_until"><br />
            <div class="mt-1"><span></span> <input type="text" v-model="wed_from2"> - <input type="text" v-model="wed_until2"></div>
            <small><input type="checkbox" v-model="wed_closed" id="wed_closed"> <label for="wed_closed">Mittwoch geschlossen</label></small>

            <span>Donnerstag:</span> <input type="text" v-model="thu_from"> - <input type="text" v-model="thu_until"><br />
            <div class="mt-1"><span></span> <input type="text" v-model="thu_from2"> - <input type="text" v-model="thu_until2"></div>
            <small><input type="checkbox" v-model="thu_closed" id="thu_closed"> <label for="thu_closed">Donnerstag geschlossen</label></small>

            <span>Freitag:</span> <input type="text" v-model="fri_from"> - <input type="text" v-model="fri_until"><br />
            <div class="mt-1"><span></span> <input type="text" v-model="fri_from2"> - <input type="text" v-model="fri_until2"></div>
            <small><input type="checkbox" v-model="fri_closed" id="fri_closed"> <label for="fri_closed">Freitag geschlossen</label></small>

            <span>Samstag:</span> <input type="text" v-model="sat_from"> - <input type="text" v-model="sat_until"><br />
            <div class="mt-1"><span></span> <input type="text" v-model="sat_from2"> - <input type="text" v-model="sat_until2"></div>
            <small><input type="checkbox" v-model="sat_closed" id="sat_closed"> <label for="sat_closed">Samstag geschlossen</label></small>

            <span>Sonntag:</span> <input type="text" v-model="sun_from"> - <input type="text" v-model="sun_until"><br />
            <div class="mt-1"><span></span> <input type="text" v-model="sun_from2"> - <input type="text" v-model="sun_until2"></div>
            <small><input type="checkbox" v-model="sun_closed" id="sun_closed"> <label for="sun_closed">Sonntag geschlossen</label></small>

            <button class="btn btn-secondary" @click="cancelEditStore()">Abbrechen</button>
            <button class="btn btn-primary" @click="saveStore()">Speichern</button>
        </div>

    </div>
</template>

<script>
    export default {

    	data() {
            return {
                mon_from: '',
                mon_until: '',
                mon_closed: '',
                tue_from: '',
                tue_until: '',
                tue_closed: '',
                wed_from: '',
                wed_until: '',
                wed_closed: '',
                thu_from: '',
                thu_until: '',
                thu_closed: '',
                fri_from: '',
                fri_until: '',
                fri_closed: '',
                sat_from: '',
                sat_until: '',
                sat_closed: '',
                sun_from: '',
                sun_until: '',
                mon_from2: '',
                mon_until2: '',
                tue_from2: '',
                tue_until2: '',
                wed_from2: '',
                wed_until2: '',
                thu_from2: '',
                thu_until2: '',
                fri_from2: '',
                fri_until2: '',
                sat_from2: '',
                sat_until2: '',
                sun_from2: '',
                sun_until2: '',
                editingStore: false
            };
        },

        mounted() {
            //console.log('Component mounted.');
            //console.log(this.storeData);
            this.mon_from = this.storeData.mon_from;
            this.mon_until = this.storeData.mon_until;
            this.mon_closed = this.storeData.mon_closed;
            this.tue_from = this.storeData.tue_from;
            this.tue_until = this.storeData.tue_until;
            this.tue_closed = this.storeData.tue_closed;
            this.wed_from = this.storeData.wed_from;
            this.wed_until = this.storeData.wed_until;
            this.wed_closed = this.storeData.wed_closed;
            this.thu_from = this.storeData.thu_from;
            this.thu_until = this.storeData.thu_until;
            this.thu_closed = this.storeData.thu_closed;
            this.fri_from = this.storeData.fri_from;
            this.fri_until = this.storeData.fri_until;
            this.fri_closed = this.storeData.fri_closed;
            this.sat_from = this.storeData.sat_from;
            this.sat_until = this.storeData.sat_until;
            this.sat_closed = this.storeData.sat_closed;
            this.sun_from = this.storeData.sun_from;
            this.sun_until = this.storeData.sun_until;
            this.sun_closed = this.storeData.sun_closed;

            this.mon_from2 = this.storeData.mon_from2;
            this.mon_until2 = this.storeData.mon_until2;
            this.tue_from2 = this.storeData.tue_from2;
            this.tue_until2 = this.storeData.tue_until2;
            this.wed_from2 = this.storeData.wed_from2;
            this.wed_until2 = this.storeData.wed_until2;
            this.thu_from2 = this.storeData.thu_from2;
            this.thu_until2 = this.storeData.thu_until2;
            this.fri_from2 = this.storeData.fri_from2;
            this.fri_until2 = this.storeData.fri_until2;
            this.sat_from2 = this.storeData.sat_from2;
            this.sat_until2 = this.storeData.sat_until2;
            this.sun_from2 = this.storeData.sun_from2;
            this.sun_until2 = this.storeData.sun_until2;
        },

        methods: {

            editStore() {
                this.editingStore = true;
            },
            cancelEditStore() {
                this.editingStore = false;
            },
            saveStore() {
                var _this = this;
                axios.put('/stores/' + this.storeData.id, this.$data)
                .then(function (response) {
                    if(response.status == 200) {
                        _this.editingStore = false;
                    }
                })
            }

        },

        props: ['storeData'],

    }
</script>